export const environment = {
    production: false,    
    apiUrl: 'https://as-global-appinlayserver-we-test.azurewebsites.net',
    redirectUrls: {
        afterSave: 'returnConfig/save',
        afterBasket: 'returnConfig/basket'
    },
    allowUrlSession: false
};
